import type { Team } from '@localagent/sdk';

export function WorkspaceArchiveTeamsNotice({
  teams,
  error,
}: {
  teams: Team[] | undefined;
  error: Error | null;
}) {
  if (error) {
    return (
      <p className="text-body text-destructive" role="alert" data-testid="workspace-archive-teams-error">
        Could not check which teams use this workspace: {error.message}
      </p>
    );
  }
  if (teams === undefined) {
    return <p className="text-body text-muted-foreground">Checking which teams use this workspace…</p>;
  }
  if (teams.length === 0) return null;
  return (
    <p className="text-body text-destructive" data-testid="workspace-archive-teams">
      This will stop {teams.length} {teams.length === 1 ? 'team' : 'teams'}:{' '}
      {teams.map((team) => team.name).join(', ')}.
    </p>
  );
}
